<template>
  <div ref="mapContainer" style="width: 100%; height: 100%;"></div>
</template>

<script>
export default {
  name: "AmapMarker",
  props: {
    center: {
      type: Object,
      default: () => ({ lng: 116.397428, lat: 39.90923 }), // 默认坐标为北京天安门
    },
    zoom: {
      type: Number,
      default: 8, // 默认缩放级别
    },
    Item: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  data() {
    return {
      map: null,
    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      var that = this;

      if (this.marker) this.map.remove(this.marker);

      var position = this.Item.location.split(",").map(Number);

      console.log(position,'position');
      

      this.map = new AMap.Map(this.$refs.mapContainer, {
        zoom: this.zoom, // 初始化地图层级
        // center: [this.center.lng, this.center.lat], // 初始化地图中心点
        center: position, // 初始化地图中心点
      });

      // 添加一个标记点
      this.marker = new AMap.Marker({
        position: position, // 经纬度对象表示
        icon: new AMap.Icon({
          // size: [36,36], // 图标尺寸
          image:
            "https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png", // Icon的图像地址
          imageSize: new AMap.Size(28, 35), // 根据所设置的大小拉伸或压缩图片
        }),
      });

      var infoWindow = null;

      //鼠标点击marker弹出自定义的信息窗体
      this.marker.on("click", function() {
        infoWindow.open(that.map, that.marker.getPosition());
      });

      this.map.add(this.marker);

      //在指定位置打开信息窗体
      function openInfo() {
        //构建信息窗体中显示的内容
        var info = [];
        info.push("<div class='input-card content-window-card'><div></div> ");
        // info.push('<div style="padding:7px 0px 0px 0px;"><h4>高德软件</h4>');
        info.push(`<p class='input-item'>设备ID :  ${that.Item.device_id}</p>`);

        infoWindow = new AMap.InfoWindow({
          offset: new AMap.Pixel(0, -30),
          autoMove: false,
          content: info.join(""), //使用默认信息窗体框样式，显示信息内容
        });

        infoWindow.open(that.map, that.map.getCenter());
      }

      openInfo();
    },
  },
  watch: {
    Item: {
      handler: function(val) {
        if (val) {
          this.Item = val;
          this.initMap();
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="less">
/deep/.input-card {
  // color: #000;
}

/deep/.amap-info-content {
  box-shadow: 1px 1px 12px 1px #3535354d;
  background: linear-gradient(to bottom, #8abdff, #0d8efe,#57a0ff);
}

/deep/.amap-info-close {
  right: 5px !important;
  color: #fff !important;
}
/deep/.amap-info-content {
  padding: 10px 22px;
}

/deep/.amap-info-sharp {
  display: none;
}

.custom-input-card {
  width: 18rem;
}

.custom-input-card .btn:last-child {
  margin-left: 1rem;
}

.content-window-card {
  position: relative;
  width: 23rem;
  padding: 0.75rem 0 0 1.25rem;
  box-shadow: none;
  bottom: 0;
  left: 0;
}

.content-window-card p {
  height: 2rem;
}
</style>
